import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

/** Pathless layout: everything below requires a session. */
export const Route = createFileRoute("/_authed")({
  beforeLoad: ({ context, location }) => {
    if (!context.user) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }
    return { user: context.user };
  },
  component: () => <Outlet />,
});
